// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","849":"06094cf0"}[chunkId] + "-" + {"293":"a59932beeff8d0bc2632","849":"00588102a92eabf0f86d"}[chunkId] + ".js";
};